import { createTheme, Shadows } from '@mui/material/styles';
import { componentOverrides } from './components';
import { ThemePreset } from './presets';
import { BRAND, ERROR, FONT_FAMILY, FONT_WEIGHT_SEMIBOLD, REQUIRED, TYPE_SCALE } from './tokens';

// Builds the admin and portal themes from one skeleton. Uses MUI v7
// `colorSchemes` so both support light + dark, following the OS preference by
// default with a manual override. Mode is switched via a class on <html> (see
// `cssVariables.colorSchemeSelector`) and persisted by MUI's `useColorScheme`
// under the `mui-mode` localStorage key.
export const createAppTheme = (preset: ThemePreset) =>
  createTheme({
    cssVariables: { colorSchemeSelector: 'class' },
    shadows: Array(25).fill('none') as Shadows,
    components: componentOverrides,
    colorSchemes: {
      light: {
        palette: {
          ...preset.light,
          brand: BRAND.light,
          required: REQUIRED.light,
          error: ERROR,
        },
      },
      dark: {
        palette: {
          ...preset.dark,
          brand: BRAND.dark,
          required: REQUIRED.dark,
          error: ERROR,
        },
      },
    },
    typography: {
      fontFamily: FONT_FAMILY,
      fontWeightSemibold: FONT_WEIGHT_SEMIBOLD,
      // Not in Typography's variantMapping, so they render as <span>.
      label: TYPE_SCALE.label,
      micro: TYPE_SCALE.micro,
    },
  });
